import documentQuery from './documentQuery';
import documentStatusUpdate from './documentStatusUpdate';
import documentDelete from './documentDelete';
import documentSend from './documentSend';
import documentGet from './documentGet';
import documentStatusGet from './documentStatusGet';
import documentDraftGet from './documentDraftGet';
import documentAttachmentGet from './documentAttachmentGet';
import documentCalculate from './documentCalculate';
import documentCreate from './documentCreate';
import documentUpdate from './documentUpdate';
import documentTransform from './documentTransform';
import allowedDocType from './allowedDocType';
import documentInfoGet from './documentInfoGet';
import documentArchive from './documentArchive';
import documentGetLatest from './documentGetLatest';
import checkField from './checkField';
import checkDocument from './checkDocument';
import invoiceDetail from './invoiceDetail';
import checkDocumentByUuid from './checkDocumentByUuid';
import getDocumnetId from './getDocumnetId';
import invoiceStatusUpdate from './invoiceStatusUpdate';

export default {
    documentQuery,
    documentStatusUpdate,
    documentDelete,
    documentSend,
    documentGet,
    documentStatusGet,
    documentDraftGet,
    documentAttachmentGet,
    documentCalculate,
    documentCreate,
    documentUpdate,
    documentTransform,
    allowedDocType,
    documentInfoGet,
    documentArchive,
    documentGetLatest,
    checkField,
    checkDocument,
    invoiceDetail,
    checkDocumentByUuid,
    getDocumnetId,
    invoiceStatusUpdate,
};


// WEBPACK FOOTER //
// ./src/api/document/index.ts